import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { VideoSelectionComponent } from "./vod/widgets/video-selection/video-selection.component";
import { ContentListComponent } from "./vod/content-list/content-list.component";
import { BasePageComponent } from "./commons/base-page/base-page.component";
import { ContentDetailComponent } from "./vod/content-detail/content-detail.component";
import { VideoSliderComponent } from "./vod/widgets/video-slider/video-slider.component";
import { DashboardComponent } from "./commons/dashboard/dashboard.component";
import { VideoCarouselComponent } from "./vod/widgets/video-carousel/video-carousel.component";
import { ContentSearchComponent } from "./vod/content-search/content-search.component";
import { AppRoutingModule } from "../app-routing.module";
import { FormsModule } from "@angular/forms";
import { ChannelDetailComponent } from "./btv/channel-detail/channel-detail.component";
import { ContentGridComponent } from "./vod/content-grid/content-grid.component";
import { ChannelGridComponent } from "./btv/channel-grid/channel-grid.component";
import { ChannelCarouselComponent } from "./btv/widgets/channel-carousel/channel-carousel.component";
import { TvGuideComponent } from "./btv/tv-guide/tv-guide.component";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { CategoryCarouselComponent } from "./vod/category-carousel/category-carousel.component";
import { PodcastDetailComponent } from "./podcast/podcast-detail/podcast-detail.component";
import { PodcastCarouselComponent } from "./podcast/widgets/podcast-carousel/podcast-carousel.component";
import { PodcastSliderComponent } from "./podcast/widgets/podcast-slider/podcast-slider.component";
import { BlogSliderComponent } from "./blog/widgets/blog-slider/blog-slider.component";
import { ChannelEpgComponent } from "./btv/channel-epg/channel-epg.component";
import { PodcastGridComponent } from "./podcast/podcast-grid/podcast-grid.component";
import { BlogGridComponent } from "./blog/blog-grid/blog-grid.component";
import { BlogDetailComponent } from "./blog/blog-detail/blog-detail.component";
import { BlogContentComponent } from './blog/blog-content/blog-content.component';

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
    ScrollPanelModule,
  ],
  declarations: [
    BasePageComponent,
    // Widgets
    VideoCarouselComponent,
    VideoSliderComponent,
    VideoSelectionComponent,
    ChannelCarouselComponent,
    // Views
    DashboardComponent,
    ContentDetailComponent,
    ContentListComponent,
    ContentGridComponent,
    ContentSearchComponent,
    ChannelGridComponent,
    ChannelDetailComponent,
    TvGuideComponent,
    CategoryCarouselComponent,
    PodcastDetailComponent,
    PodcastCarouselComponent,
    PodcastSliderComponent,
    BlogSliderComponent,
    ChannelEpgComponent,
    PodcastGridComponent,
    BlogGridComponent,
    BlogDetailComponent,
    BlogContentComponent,
  ],
  providers: [DatePipe],
  exports: [CategoryCarouselComponent],
})
export class ViewsModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/views.module.ts